import Footer from "components/footer/FooterAuthDefault";
import logoMark from "assets/img/brand/logo-mark.svg";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full !bg-white dark:!bg-navy-900">
        <FixedPlugin />
        <main className={`mx-auto min-h-screen`}>
          <div className="relative flex">
            <div className="mx-auto flex min-h-full w-full flex-col justify-start pt-12 md:max-w-[75%]  lg:max-w-[1013px] lg:px-8 lg:pt-0 xl:min-h-[100vh] xl:max-w-[1383px] xl:px-0 xl:pl-[70px]">
              <div className="mb-auto flex flex-col pl-5 pr-5 md:pr-0 md:pl-12 lg:max-w-[48%] lg:pl-0 xl:max-w-full">
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/auth/sign-in" replace />}
                  />
                </Routes>
                <div className="absolute right-0 hidden h-full min-h-screen md:block lg:w-[49vw] 2xl:w-[44vw]">
                  <div
                    className="absolute flex h-full w-full flex-col items-center justify-center gap-6 lg:rounded-bl-[120px] xl:rounded-bl-[200px]"
                    style={{
                      background:
                        "radial-gradient(circle at 15% 15%, rgba(255,255,255,0.14), transparent 45%), radial-gradient(circle at 85% 85%, rgba(255,255,255,0.10), transparent 45%), linear-gradient(135deg, #9b5de5, #D4AF37)",
                    }}
                  >
                    <div className="flex h-32 w-32 items-center justify-center rounded-full bg-white/15 backdrop-blur-sm">
                      <img
                        src={logoMark}
                        alt="Findule"
                        className="h-16 w-16"
                        style={{ filter: "brightness(0) invert(1)" }}
                      />
                    </div>
                    <p className="text-2xl font-bold text-white">Findule</p>
                    <p className="max-w-[280px] text-center text-sm text-white/80">
                      Painel interno de gestão de assinantes
                    </p>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
